window.addEventListener('DOMContentLoaded', function () {
  jQuery(function ($) {
    let carousel = new Swiper(
      '.unique-selling-points-carousel.swiper:not(.swiper-initialized)',
      {
        slidesPerView: 1,
        allowTouchMove: true,
        autoplay: {
          delay: 5000,
        },
        breakpoints: {
          768: {
            slidesPerView: 2,
            allowTouchMove: true,
            loop: false,
          },
          1280: {
            slidesPerView: 'auto',
            allowTouchMove: false,
            loop: false,
          },
        },
      },
    );
  });
});
